module.exports = __webpack_public_path__ + "img/a_task.b34f07d9.png";